import Profile from './Profile';
import Picture from './Picture';

Profile.Picture = Picture;

export default Profile